import { ParentModel } from './parent.model';
import { PreviewCrossesModel } from './preview-crosses.model';

export class CreatePreviewCrossesRequestModel {

    constructor(
        public studyId: number,
        public femaleParents: ParentModel[],
        public maleParents: ParentModel[],
        public existingCrosses: PreviewCrossesModel[],
        public crossType: string,
        public makeReciprocalCrosses: boolean,
        public excludeSelf: boolean,
    ) {
    }
}
